<template>
	<div id="managepropertyview" class="viewport">
		<div class="columns">
			<div class="column">
				<h1>Properties</h1>
			</div>
			<div class="column alignRight">
				<button class="button is-pulled-right" v-on:click="newProperty">Neue Property</button>
			</div>
		</div>
		<div class="columns">
			<div class="column">
				<div class="borderround">				
					<div class="property head">
						<div class="inline abk">ABK</div>
						<div class="inline domain">Domain</div>
						<div class="inline onoff">On/Off</div>
						<div class="inline actions"></div>		
					</div>				
					<property :property.sync="property" :key="property.id" v-for="(property, key, index) in properties"></property>
				</div>
			</div>
		</div>
	</div>
</template>
</template>
<script>
import Property from '@/components/Properties/Property';

export default {

	name: "ManagePropertiesView",
	components: {
		Property
	},
	data() {
	    return {
	      		properties: [],      		
			  }
	},
	sockets: {
		syncPropertyList(r){
			console.log(r)
			this.properties = []			
			this.properties = r 
		}
	},
	methods: {
		newProperty(e){
			e.preventDefault();
			this.$router.replace({ name: "ManageProperty", params: {propid: 'new' } })
		}
	},
	
	mounted: function(){
		this.$socket.emit('getPropertyList');
	}
}
</script>
<style>
</style>